export default "__VITE_ASSET__CPRsw8go__"